var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"kbo-zzim"},[(_vm.alarmYn === 'Y')?_c('button',{staticClass:"kbo-zzim-button"},[_c('img',{attrs:{"src":require("../../assets/images/kbo/icon-alart-on.png"),"alt":"시청 예약"}})]):_c('button',{staticClass:"kbo-zzim-button"},[_c('img',{attrs:{"src":require("../../assets/images/kbo/icon-alart-off.png"),"alt":"시청 예약 취소"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }